"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var discardTxpOption_1 = require("./actions/discardTxpOption");
var saveTxpOption_1 = require("./actions/saveTxpOption");
var TxpFull_1 = require("./components/TxpFull");
var isTxpOptionDirty_1 = require("./utils/isTxpOptionDirty");
var React = require("react");
/**
 * Txp options settings
 */
var TxpOption = {
    key: 'txp',
    titleStringKey: 'optionTitle_eventsForEmail',
    searchTermsStringKey: 'optionTitle_eventsForEmail',
    fullOptionFormSettings: {
        render: function () { return React.createElement(TxpFull_1.default, null); },
        isDirty: isTxpOptionDirty_1.default,
        onSave: saveTxpOption_1.default,
        onDiscard: discardTxpOption_1.default,
    },
};
exports.default = TxpOption;
//# sourceMappingURL=TxpOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-txp-option/lib/TxpOption.js
// module id = 5266
// module chunks = 2